import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button } from "react-bootstrap";
import "../../styles/ibutton/ibutton.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal } from "../../utils/dateConvert";

class DeleteIbutton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerName: "",
      serialNo: "",
      name: "",
      statee: "",
      lastevent: "",
      assetName: "",
      deviceName: "",
      lastDisconnect: "",
      lastConnect: "",
      statusName: "",
      id: "",
      created: "",
      updated: "",
    };
  }

  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/IButton/SelectIButton/${this.props.match.params.id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setData(response.data[0]);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
    }
  }

  setData = (data) => {
    const {
      name,
      lastDisconnect,
      state,
      deviceName,
      lastConnect,
      assetName,
      lastevent,
      status,
      serialNo,
      customerName,
      id,
      dbCreated,
      dbUpdated,
    } = data;

    this.setState({
      name,
      lastDisconnect,
      assetName,
      lastConnect,
      deviceName,
      lastevent,
      statee: state,
      serialNo,
      customerName,
      statusName: status,
      id,
      created: dbCreated,
      updated: dbUpdated,
    });
  };

  handleBack = () => {
    this.props.history.push("/ibutton");
  };

  deleteIbutton = async () => {
    this.props.setLoadingPageAction(true);

    try {
      await axios.get(
        `${apiHost}/api/IButton/DeleteIButton/${this.props.match.params.id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.props.setLoadingPageAction(false);
      this.props.history.push("/ibutton");
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
    }
  };

  normalizeConnectionState = (state) => {
    const normalizedState = (state || "").toString().toLowerCase();

    if (normalizedState === "connected") {
      return "connected";
    }

    if (normalizedState === "disconnected") {
      return "disconnected";
    }

    return "unknown";
  };

  normalizeStatus = (status) => {
    const normalizedStatus = (status || "").toString().toLowerCase();

    if (normalizedStatus === "disabled" || normalizedStatus === "disable" || normalizedStatus === "0") {
      return "disabled";
    }

    if (normalizedStatus === "active" || normalizedStatus === "enabled" || normalizedStatus === "1") {
      return "active";
    }

    return "unknown";
  };

  renderField = (label, value, className = "") => (
    <div className="ibutton-detail-field">
      <span>{label}</span>
      <strong className={className}>{value || "-"}</strong>
    </div>
  );

  render() {
    const {
      name,
      statee,
      deviceName,
      lastDisconnect,
      lastConnect,
      assetName,
      lastevent,
      serialNo,
      statusName,
      customerName,
      created,
      updated,
    } = this.state;
    const connectionState = this.normalizeConnectionState(statee);
    const statusState = this.normalizeStatus(statusName);

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Delete iButton </title>
          </Helmet>
          <div className="contentBody ibutton-page-shell">
            <div className="contentWrapper ibutton-detail-page">
              <div className="ibutton-detail-header">
                <div>
                  <span className="ibutton-detail-kicker">Delete iButton</span>
                  <h2>{name || "iButton"}</h2>
                  <div className="ibutton-detail-subtitle">
                    <span>{serialNo || "No serial"}</span>
                    <span className={`ibutton-connection ibutton-connection-${connectionState}`}>
                      {statee || "-"}
                    </span>
                    <span className={`ibutton-status ibutton-status-${statusState}`}>
                      {statusName || "-"}
                    </span>
                  </div>
                  <p>This will permanently remove the iButton record.</p>
                </div>
              </div>

              <section className="ibutton-detail-tile ibutton-delete-warning">
                <div className="ibutton-detail-section-title">
                  <h3>Confirm Delete</h3>
                  <p>Review this iButton before deleting it.</p>
                </div>

                <div className="ibutton-detail-grid">
                  {this.renderField("Customer", customerName)}
                  {this.renderField("Serial No", serialNo)}
                  {this.renderField("Name", name)}
                  {this.renderField("Asset", assetName)}
                  {this.renderField("Device", deviceName)}
                  {this.renderField("Last Event", utcToLocal(lastevent))}
                  {this.renderField("Last Connected", utcToLocal(lastConnect))}
                  {this.renderField("Last Disconnected", utcToLocal(lastDisconnect))}
                </div>
              </section>

              <div className="ibutton-detail-meta">
                <div>
                  <span>Created</span>
                  <strong>{utcToLocal(created)}</strong>
                </div>
                <div>
                  <span>Updated</span>
                  <strong>{utcToLocal(updated)}</strong>
                </div>
              </div>

              <div className="ibutton-detail-footer">
                <Button variant="outline-secondary" onClick={this.handleBack}>
                  Back to List
                </Button>
                <Button className="ibutton-danger-button" variant="danger" onClick={this.deleteIbutton}>
                  Delete iButton
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteIbutton);
